var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.194 96.194C138.88 53.508 195.633 30 256 30c46.164 0 90.796 14.043 128.331 39.967l-28.977 2.972 3.061 29.843 78-8-8-78-29.844 3.061 2.594 25.291C358.687 15.857 308.208 0 256 0 187.62 0 123.333 26.629 74.981 74.981S0 187.62 0 256c0 51.192 15.064 100.605 43.563 142.895l24.878-16.765c-.345-.513-.68-1.03-1.021-1.545C42.938 343.609 30 300.576 30 256c0-60.366 23.508-117.12 66.194-159.806zM468.438 113.105l-24.879 16.765c.345.512.68 1.031 1.021 1.545C469.061 168.391 482 211.424 482 256c0 60.367-23.508 117.12-66.194 159.806C373.121 458.492 316.368 482 256 482c-46.164 0-90.796-14.043-128.331-39.967l28.977-2.972-3.061-29.843-78 8 8 78 29.844-3.061-2.594-25.291C153.314 496.143 203.793 512 256 512c68.38 0 132.667-26.629 181.02-74.981C485.372 388.667 512 324.38 512 256c0-51.192-15.063-100.605-43.562-142.895z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.983 287.484 19.42-17.949c14.712-13.535 17.508-22.657 17.508-32.661 0-19.126-16.331-31.337-40.017-31.337-20.303 0-34.868 8.533-42.665 21.48l21.627 12.064c4.119-6.62 10.887-10.004 18.39-10.004 8.827 0 13.241 3.972 13.241 10.593 0 4.267-1.177 8.975-9.416 16.625L84.525 292.34v18.243h80.181v-23.098h-39.723zM257.252 290.868h15.3V267.77h-15.3v-17.507H229.74v17.507h-20.891l41.929-60.173h-30.16l-46.196 64.292v18.979h54.435v19.714h28.395zM299.038 325.294l48.549-138.588h-24.863l-48.55 138.588zM372.305 246.584v-15.889h27.07l-34.72 79.887h31.778l36.339-84.742v-18.243h-85.331v38.987z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.3327e17d2146c2a1aed8fd451830c25e.svg";
export { ForwardRef as ReactComponent };